import { render, staticRenderFns } from "./Intake.vue?vue&type=template&id=3665b7e4&scoped=true"
import script from "./Intake.vue?vue&type=script&lang=js"
export * from "./Intake.vue?vue&type=script&lang=js"
import style0 from "./Intake.vue?vue&type=style&index=0&id=3665b7e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665b7e4",
  null
  
)

export default component.exports